// Brand: the 24-game is the primary mark; "from nerdle labs" tags it as part of the
// nerdle labs suite of research games (rebus, cryptic clue, … to follow).
//
// Lives in shared/ so every screen (incl. shared ones like BrowserGate/StatusScreen)
// can render the header. The "24-game" title is hardcoded for the only game today —
// when the suite grows, parameterise it (e.g. a `game` prop) so each game sets its own.
export const Brand = () => (
  <div className="text-center select-none">
    <div className="leading-none">
      <span className="text-3xl font-extrabold text-[#820458]">24</span>
      <span className="text-2xl font-semibold text-gray-400">-game</span>
    </div>
    <div className="mt-1 text-xs text-gray-400">
      from <span className="nerdle-name">nerdle</span> <span className="nerdle-sub-name">labs</span>
    </div>
  </div>
)
